module.exports = __webpack_public_path__ + "static/media/p8.4d4440e1.svg";